export default "__VITE_ASSET__a16b30d8__"